export const creditsNavChipLabel = ({ total, dailyRemaining, hasTopUps, compact, }) => {
    const count = hasTopUps ? total : (dailyRemaining ?? total);
    if (compact)
        return { count };
    return { count, suffix: hasTopUps ? "left" : "left today" };
};
//# sourceMappingURL=creditsNavChipLabel.js.map